import React, { useState, useEffect, useContext, useRef } from 'react'
import { ContentInner } from '../../../../../layout/Content'
import ProductsWithExpirationsInnerStyle from './css/ProductsWithExpirationsInnerStyle'
import { appContext } from '../../../../../../App'
import { productsWithExpirationsControllerContext } from './ProductsWithExpirationsController'
import { dateYMD } from '../../../../../utilities/utilities'
import PrinterSettingsStyle from '../../../../../../css/PrinterSettingsStyle'

function useProductsWithExpirations(props) {
  const app = useContext(appContext)
  const productsWithExpirationsController = useContext(productsWithExpirationsControllerContext)
  const { filter, getWarehouses, getProductsInventory } = productsWithExpirationsController
  const [productsInventory, setProductsInventory] = useState(null)
  const warehouseFilter = useRef([])
  const classificationFilter = useRef([])

  useEffect(() => {
    const init = async () => {
      const initProductsInventory = async (warehouses) => {
        const prodInv = []

        for (let warehouse of warehouses) {
          // Filter the warehouse
          if (warehouseFilter.current.find(wh => (wh === warehouse.name))) {
            let products = await getProductsInventory(app, warehouse._id)

            // Filter the products
            products = products.filter(product => (
                classificationFilter.current.find(classification => (classification === product.classification))
              )
            )

            prodInv.push (
              {
                wh: warehouse,
                products: products
              }
            )
          }
        }
        setProductsInventory(prodInv)
      }

      // Warehouse filter
      for (let key in filter.warehouse) {
        if (filter.warehouse[key]) {
          //push into temp array here
          warehouseFilter.current.push(key)
        }
      }

      // Classification filter
      for (let key in filter.classification) {
        if (filter.classification[key]) {
          classificationFilter.current.push(key)
        }
      }

      initProductsInventory(await getWarehouses(app))
    }

    init()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const obj = {
    app,
    productsInventory: [productsInventory, setProductsInventory],
    classifications: classificationFilter.current
  }

  return (obj)
}

function ExpirationsList({unit_description, expirations}) {
  return (
    <React.Fragment>
      {
        (expirations)
        ? expirations.map((exp, index) => (
            <tr key={index}>
              <td style={{textAlign: 'center'}}>{dateYMD(new Date(exp.date))}</td>
              <td style={{textAlign: 'center'}}>{unit_description}</td>
              <td style={{textAlign: 'center'}}>{exp.quantity}</td>
            </tr>
          ))
        : null
      }
    </React.Fragment>
  )
}

function ProductsListContents({product, wh_id}) {
  const expirationExist = () => {
    let expiration_exist = false
    product.units.forEach(unit => {
      const warehouse = unit.warehouses.find(wh => wh.warehouse_id === wh_id)
      if (warehouse)
        if (warehouse.expirations)
          expiration_exist |= Boolean(warehouse.expirations.length)
    })
    return (expiration_exist)
  }

  if (!expirationExist()) return null

  return (
    <div className='product-container'>
      <table className='inventory-table'>
        <thead>
          <tr>
            <td className='product-name-th' colSpan='3'>{`${product.brand} ${product.name} ${product.description}`}</td>
          </tr>
          <tr>
            <th>Expiration Date</th>
            <th>Unit</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          {
            product.units.map((unit, index) => (
              (unit.warehouses.find(wh => wh.warehouse_id === wh_id))
              ? <ExpirationsList
                  key={index}
                  expirations={unit.warehouses.find(wh => wh.warehouse_id === wh_id).expirations}
                  unit_description={unit.description}
                />
              : null
            ))
          }
        </tbody>
      </table>
    </div>
  )
}

function ProductsWithExpirationsInner(props) {
  const productsWithExpirations = useProductsWithExpirations(props)
  const { app } = productsWithExpirations
  const productsInventory = productsWithExpirations.productsInventory[0]
  const classifications = productsWithExpirations.classifications

  const expirationExist = (pi, classification) => {
    let expiration_exist = false
    pi.products
    .filter(product => (product.classification === classification))
    .forEach(product => {
      product.units.forEach(unit => {
        const warehouse = unit.warehouses.find(wh => wh.warehouse_id === pi.wh._id)
        if (warehouse)
          if (warehouse.expirations)
            expiration_exist |= Boolean(warehouse.expirations.length)
      })
    })
    return (expiration_exist)
  }

  return (
    <ContentInner>
      <div className='report-wrapper'>
        <div id='products-list-container' className='printable'>
          {
            (productsInventory) ?
              productsInventory.map((pi, i) => (
                <div
                  key={i}
                  className={ (i === 0) ? 'firstpage' : (i === (productsInventory.length - 1)) ? 'lastpage' : 'pagebreak' }>
                  <div className='products-inventory-header-container'>
                    <div className='products-inventory-header'>Products With Expirations Inventory</div>
                    <div className='products-inventory-date'>As of {new Date(app.getClientDateTime()).toLocaleString("en-us")} { app.getClientTimezone() }</div>
                  </div>
                  <br />
                  <div><b>Warehouse:</b> {pi.wh.name}</div>
                  <hr />
                  {
                    (classifications) ?
                      classifications.map((classification, index) => (
                        <div
                          key={index}
                          style={{display: (expirationExist(pi, classification)) ? 'block' : 'none'}}
                          className='classification-container'>
                          <div><b>Classification:</b> {classification}</div>
                          {
                            pi.products
                            .filter(product => (product.classification === classification))
                            .map((product, index) => (
                              <ProductsListContents key={index} product={product} wh_id={pi.wh._id}/>
                            ))
                          }
                        </div>
                      ))
                    : null
                  }
                </div>
              ))
            : null
          }
        </div>
      </div>
      <ProductsWithExpirationsInnerStyle />
      <PrinterSettingsStyle paperWidth='8.5inch'/>
    </ContentInner>
  )
}

export default React.memo(ProductsWithExpirationsInner)